const timeline_slider = document.querySelector('#c-timeline_slider');

if (timeline_slider) {
  window.slides = document.querySelectorAll('.c-timeline_slider__slide');
  window.next_arrows = document.querySelectorAll('.c-timeline_slider__up');
  window.previous_arrows = document.querySelectorAll('.c-timeline_slider__down');
  window.currentSlide = 0;
}

function init() {

  if (!timeline_slider) {
    return;
  }

  const controls_down = document.querySelectorAll('.c-timeline_slider__down');

  Array.from(controls_down).forEach((control_down) => {
    control_down.addEventListener('click', (e) => {
      next_slide();
    });
  });

  const controls_up = document.querySelectorAll('.c-timeline_slider__up');

  Array.from(controls_up).forEach((control_up) => {
    control_up.addEventListener('click', (e) => {
      previous_slide();
    });
  });

  //next_arrows[0].classList.add('disabled');
  //previous_arrows[slides.length-1].classList.add('disabled');

  var slide = document.querySelectorAll('.c-timeline_slider__slide')[0];
  var events_element = slide.querySelectorAll('.c-timeline_slider__description');
  var event_element = events_element[events_element.length-1];
  event_element.classList.remove('c-timeline_slider__description');
  event_element.classList.add('c-timeline_slider__description_tail');

  var slide = document.querySelectorAll('.c-timeline_slider__slide')[1];
  var events_element = slide.querySelectorAll('.c-timeline_slider__description');
  var event_element = events_element[events_element.length-1];
  event_element.classList.remove('c-timeline_slider__description');
  event_element.classList.add('c-timeline_slider__description_tail');

}

function next_slide() {

  //if(currentSlide != (slides.length - 1)) {

    slides[currentSlide].className = 'c-timeline_slider__slide';
    currentSlide = (currentSlide + 1) % slides.length;
    slides[currentSlide].className = 'c-timeline_slider__slide is-active';
    slides[currentSlide].style.height = slides[currentSlide].getBoundingClientRect().height;
    document.querySelector('#c-timeline_slider').style.height = slides[currentSlide].getBoundingClientRect().height;

  //}

}

function previous_slide() {

  //if(currentSlide != 0) {

    slides[currentSlide].className = 'c-timeline_slider__slide';
    currentSlide = (currentSlide == 0) ? slides.length - 1 : (currentSlide - 1) % slides.length;
    slides[currentSlide].className = 'c-timeline_slider__slide is-active';
    slides[currentSlide].style.height = slides[currentSlide].getBoundingClientRect().height;
    document.querySelector('#c-timeline_slider').style.height = slides[currentSlide].getBoundingClientRect().height;

  //}

}

export default init;
